import p5 from 'p5';
import 'p5/lib/addons/p5.sound';
import getPitch from './pitch-detection';
import colorAlpha from './color-alpha';
import frequencyToColor from './frequency-to-color';
import mouseMovedInLast2Seconds, {
  updateMouseMoved,
} from './mouse-moved-in-last-2-seconds';

export default function sketch(p) {
  let canvas;
  let mic;
  let fft;
  let bands = 64;
  let storedDataLen = 125;
  let spectrums;
  let currentSpectrum = 0;
  let amplitude;
  let space = 20;
  let items;

  function initializeStoredData() {
    return range(storedDataLen).map(x => ({
      spectrum: range(bands).map(x => 0),
    }));
  }

  function range(x) {
    let ret = [];
    for (let i = 0; i < x; i++) {
      ret.push(i);
    }
    return ret;
  }

  p.setup = function setup() {
    canvas = p.createCanvas(window.innerWidth, window.innerHeight);
    mic = new p5.AudioIn();
    mic.start();
    amplitude = new p5.Amplitude();
    amplitude.setInput(mic);
    fft = new p5.FFT(0.8, bands);
    fft.setInput(mic);
    spectrums = initializeStoredData();
    p.orbitControl();
    p.background(0);

    items = range(300).map(() => new Item());
  };

  function drawSpectrum({spectrum, spectrumColor}) {
    p.noFill();
    p.stroke((spectrumColor === 'black' ? 'white' : spectrumColor) || 'white');
    p.beginShape();
    p.curveVertex(0, 0);
    for (let i = 0; i < bands; i++) {
      let endX = p.map(i, 0, bands, 0, p.width);
      let endY = p.height - p.map(spectrum[i], 0, 255, 0, p.height);
      p.curveVertex(endX, endY);
    }
    p.curveVertex(p.width, 0);
    p.endShape();
  }

  let lastColor = 'white';
  p.draw = function draw() {
    p.background(colorAlpha(p, 0, 0.05));

    const cZ = 1000;
    // const cX = 0; // cZ;
    // const cY = 1000;
    const cX = p.mouseX - p.width / 2;
    const cY = p.mouseY - p.height / 2;
    // p.ambientLight(100);
    // p.pointLight(250, 250, 250, 100, 100, 0);

    // p.camera(
    //   cX,
    //   cY,
    //   cZ, // x, y, z
    //   0,
    //   0,
    //   0, // cX, cY, cZ
    //   0,
    //   1,
    //   0, // upX, upY, upZ
    // );

    /*
    camera(
      0, 0, cY, // x, y, z
      0, 0, 0,  // cX, cY, cZ
      0, 0, 0   // upX, upY, upZ
    );
    */

    // p.translate(-p.width / 2, -p.height / 2);

    const level = amplitude.getLevel();
    const size = 80 + 200 * level;

    // p.ambientLight(255, 0, 10, 30);

    // translate(0, 0, -4 * storedDataLen - 10);
    // noFill();
    // stroke(0, 0, 255);
    // ellipse(width / 2, height / 2, size);
    // translate(0, 0, 4 * storedDataLen + 10);

    p.translate(0, -10);

    const spectrum = fft.analyze();
    const waveform = fft.waveform(1024, 'float32');
    const freq = getPitch(p, waveform);
    const fToColor = frequencyToColor(p, freq, level);
    let {color, noteName, targetFrequency} = fToColor;

    if (color === 'black') {
      color = 'white';
    }

    if (lastColor !== color) {
      color = p.lerpColor(p.color(lastColor), p.color(color), 0.33);
      lastColor = color;
    }

    items.forEach(item => item.update({level}));
    items.forEach(item => item.display({color}));

    // spectrums[currentSpectrum] = {spectrum, spectrumColor: color};

    // currentSpectrum = (currentSpectrum + 1) % storedDataLen;

    // for (let i = 0; i < storedDataLen; i++) {
    //   let index = (storedDataLen - 1 - i + currentSpectrum) % storedDataLen;
    //   if (index < 0) {
    //     index = storedDataLen + index;
    //   }
    //   drawSpectrum(spectrums[index]);
    //   p.translate(0, 0, -space);
    // }

    updateMouseMoved(p);
  };

  class Item {
    constructor() {
      this.x = p.random(0, p.width);
      this.y = p.random(0, p.height);
      this.size = 0;
      this.velocity = 0.01;
    }

    update({level}) {
      this.velocity = p.lerp(this.velocity, level * 10, 0.01);
      this.x = p.lerp(this.x, p.random(0, p.width), this.velocity);
      this.y = p.lerp(this.y, p.random(0, p.height), this.velocity);
      this.size = p.lerp(this.size, level * 500, 0.01);
    }

    display({color}) {
      p.stroke(color);
      p.fill(color);

      if (
        mouseMovedInLast2Seconds(p) &&
        p.mouseX > this.x - this.size * 2 &&
        p.mouseX < this.x + this.size * 3 &&
        p.mouseY > this.y - this.size * 2 &&
        p.mouseY < this.y + this.size * 3
      ) {
        p.stroke('black');
        p.fill('black');
        // p.translate(-10);
      }

      p.rect(this.x, this.y, this.size, this.size);
    }
  }

  p.touchStarted = function touchStarted() {
    p.getAudioContext().resume();
  };
}



// WEBPACK FOOTER //
// ./src/sketches/frequency-in-color.js